import { useSelector } from 'react-redux';

export default function useResourceCount(by = 'user') {
  const count = useSelector((state: any) => state.metrics?.resourceCount) || {};
  const result = count?.[by];
  return { ...result, ...count };
}
